/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ClaimEvidenceControllerFindAllQueryResponse, ClaimEvidenceControllerFindAllQueryParams, ClaimEvidenceControllerFindAll401, ClaimEvidenceControllerFindAll403 } from "../../models/checklistsController/ClaimEvidenceControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { claimEvidenceControllerFindAll } from "../../clients/checklistsService/claimEvidenceControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const claimEvidenceControllerFindAllQueryKey = (params: ClaimEvidenceControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/checklist-application-claim-evidence'
}, ...(params ? [params] : [])] as const;
export type ClaimEvidenceControllerFindAllQueryKey = ReturnType<typeof claimEvidenceControllerFindAllQueryKey>;
export function claimEvidenceControllerFindAllQueryOptions(params?: ClaimEvidenceControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = claimEvidenceControllerFindAllQueryKey(params);
  return queryOptions<ClaimEvidenceControllerFindAllQueryResponse, ResponseErrorConfig<ClaimEvidenceControllerFindAll401 | ClaimEvidenceControllerFindAll403>, ClaimEvidenceControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return claimEvidenceControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List checklist claim evidence
 * {@link /api/v1/checklist-application-claim-evidence}
 */
export function useClaimEvidenceControllerFindAll<TData = ClaimEvidenceControllerFindAllQueryResponse, TQueryData = ClaimEvidenceControllerFindAllQueryResponse, TQueryKey extends QueryKey = ClaimEvidenceControllerFindAllQueryKey>(params?: ClaimEvidenceControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<ClaimEvidenceControllerFindAllQueryResponse, ResponseErrorConfig<ClaimEvidenceControllerFindAll401 | ClaimEvidenceControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? claimEvidenceControllerFindAllQueryKey(params);
  const query = useQuery({
    ...claimEvidenceControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClaimEvidenceControllerFindAll401 | ClaimEvidenceControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}